import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';

const ImageLightBoxContainer = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const WebcamContainer = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text {
    font-size: 26px;
    font-weight: 300;
  }
  .capture-button {
    width: 180px;
    background-color: ${(props) => props.theme.colors.green};
    color: #ffffff;

    &:hover {
      opacity: .7;
    }
  }
`;

const WebcamCaptureImage = () => {
  const image = useSelector((state) => state.feed.data.messageMediaUrl);

  return (
    <WebcamContainer>
      <ImageLightBoxContainer
        src={image}
      />
    </WebcamContainer>
  );
};

WebcamCaptureImage.propTypes = {
};

export default WebcamCaptureImage;
